import {VoucherCodeQuery} from '@/ts/types/component/sign-up-type';

/**
 * Partners with visual branding, keyed by their URL code, with the organization-name
 * fragments that identify them (e.g. both "Urban Sports Club" and "USC" org names map
 * to the USC branding); ZIM deliberately has none.
 */
const PARTNER_NAME_FRAGMENTS: Partial<Record<VoucherCodeQuery, string[]>> = {
  [VoucherCodeQuery.ALLIANZ]: ['allianz'],
  // 'urban' alone is a generic word ("Urban Health GmbH" is not USC).
  [VoucherCodeQuery.URBAN_SPORTS_CLUB]: ['urban sports', 'usc'],
};

/** Escapes regex metacharacters so future fragments can't silently mis-match. */
function toWholeWordRegExp(fragment: string): RegExp {
  // ?. appeases sonarjs/null-dereference — its flow analysis doesn't trust the param type.
  const escaped = fragment?.replace(/[.*+?^${}()|[\]\\]/gu, '\\$&') ?? '';
  return new RegExp(`\\b${escaped}\\b`, 'u');
}

/** The partner codes that carry visual branding, in matching-priority order */
export const BRANDED_PARTNERS = Object.keys(PARTNER_NAME_FRAGMENTS) as VoucherCodeQuery[];

/**
 * Whether an organization name identifies the given partner. Whole-word matching
 * so e.g. a "Muscular Health" org never triggers the USC branding via the "usc"
 * fragment; multi-word fragments match across their internal spaces.
 */
export function organizationMatchesPartner(organizationName: string | null | undefined, code: VoucherCodeQuery): boolean {
  const name = organizationName?.toLowerCase();
  if (!name) {
    return false;
  }
  return PARTNER_NAME_FRAGMENTS[code]?.some((fragment) => toWholeWordRegExp(fragment).test(name)) ?? false;
}
